import { form, phoneToCall, primaryColor } from "../../utils/variables";
import { loadLocationList } from "../../views/pages/locations";

const renderUILocationCall = () => {

    const locationElement = document.querySelector('.callus_container .callus')
    if (!locationElement) return "";

    loadLocationList(locationElement, true)
    document.querySelector(".callus_container")?.style.setProperty('--background-color', `${primaryColor}1A`);
}

export { renderUILocationCall }